module.exports = __webpack_public_path__ + "img/page-not-found.c9447f74.svg";